module.exports = __webpack_public_path__ + "img/right3.669212e9.png";